import { createFileRoute } from '@tanstack/react-router'

export const DASHBOARD_TABS = {
  WORKSTREAM: 'workstream',
  SEPARATION_COSTS: 'separation-costs',
  P_L: 'p&l',
  KANBAN: 'kanban',
  CHARTS: 'charts',
} as const

export type DashboardTabId = (typeof DASHBOARD_TABS)[keyof typeof DASHBOARD_TABS]
export const dashboardTabs = Object.values(DASHBOARD_TABS)

const validTabs = new Set<string>(dashboardTabs)

export const Route = createFileRoute('/_auth-routes/$programId/$deliverableId/$tab')({
  params: {
    parse: (params) => ({
      ...params,
      tab: (validTabs.has(params.tab) ? params.tab : DASHBOARD_TABS.WORKSTREAM) as DashboardTabId,
    }),
    stringify: (params) => ({
      ...params,
      tab: params.tab,
    }),
  },
})
